import {
  CLAIMS_CLAIMDETAIL_SAVE_LOADING,
  CLAIMS_CLAIMDETAIL_SAVE_SUCCESS,
  CLAIMS_CLAIMDETAIL_LOAD_DATA,
  CLAIMS_CLAIMDETAIL_SAVE_FAIL,
  CLAIMS_CLAIMDETAIL_LEAVECLAIM,
  CLAIMS_CLAIMDETAIL_CLAIMANT,
  CLAIMS_CLAIMDETAIL_INIT_LOADING,
  CLAIMS_CLAIMDETAIL_INIT_SUCCESS,
  CLAIMS_CLAIMDETAIL_INIT_FAIL,
  CLAIMS_CLAIMDETAIL_CLAIMITEM,
  CLAIMS_CLAIMDETAIL_SERVICEPROVIDER,
  CLAIMS_CLAIMDETAIL_RESERVES,
  CLAIMS_CLAIMPAYMENT_SELECTEDRESERVES,
  CLAIMS_CLAIMDETAIL_CLAIMHANDLERS,
  CLAIMS_PROCESS_NOTIF_SET,
  CLAIMS_PROCESS_NOTIF_RESET,
  CLAIMS_PROCESS_NOTIF_FAIL,
  CLAIMS_LOAD_BACK_LISTING,
  CLAIMS_TRANDATE_CHANGED,
  CLAIMS_HASRIORRESADJ,
  UPDATE_CLM_PEND_EXIST_LIST
} from '@/store/types'
import clone from 'clone'
// import { formatServerTimeFormat } from '@/utils/date'
import { removeFormatNumber } from '@/utils/number'

export const claim = {
  [CLAIMS_CLAIMDETAIL_SAVE_LOADING](state) {
    state.claimDetail.saving = true
    state.claimDetail.saveError.fieldMessages = []
    state.claimDetail.saveError.messages = []
  },
  [CLAIMS_CLAIMDETAIL_SAVE_SUCCESS](state) {
    state.claimDetail.saving = false
    state.claimDetail.saveError.fieldMessages = []
    state.claimDetail.saveError.messages = []
  },
  [CLAIMS_PROCESS_NOTIF_FAIL](state, errMsgs) {
    state.procNotif.saveError.fieldMessages = errMsgs.fieldMessages
    state.procNotif.saveError.messages = errMsgs.messages
  },
  [CLAIMS_LOAD_BACK_LISTING](state, data) {
    state.loadListing.action = data.action
  },
  [CLAIMS_PROCESS_NOTIF_SET](state, data) {
    state.procNotif.show = (data.show === undefined ? false : data.show)
    state.procNotif.notifType = (data.notifType === undefined ? '' : data.notifType)
    state.procNotif.clmNo = (data.clmNo === undefined ? '' : data.clmNo)
    state.procNotif.emailInsured = (data.emailInsured === undefined ? false : data.emailInsured)
    state.procNotif.emailAddressInsured = (data.emailAddressInsured === undefined ? '' : data.emailAddressInsured)
    state.procNotif.smsInsured = (data.smsInsured === undefined ? false : data.smsInsured)
    state.procNotif.smsNumberInsured = (data.smsNumberInsured === undefined ? '' : data.smsNumberInsured)
    state.procNotif.emailAgent = (data.emailAgent === undefined ? false : data.emailAgent)
    state.procNotif.emailAddressAgent = (data.emailAddressAgent === undefined ? '' : data.emailAddressAgent)
    state.procNotif.smsAgent = (data.smsAgent === undefined ? false : data.smsAgent)
    state.procNotif.smsNumberAgent = (data.smsNumberAgent === undefined ? '' : data.smsNumberAgent)
  },
  [CLAIMS_PROCESS_NOTIF_RESET](state) {
    state.procNotif.show = false
    state.procNotif.notifType = ''
    state.procNotif.clmNo = ''
    state.procNotif.emailInsured = false
    state.procNotif.emailAddressInsured = ''
    state.procNotif.smsInsured = false
    state.procNotif.smsNumberInsured = ''
    state.procNotif.emailAgent = false
    state.procNotif.emailAddressAgent = ''
    state.procNotif.smsAgent = false
    state.procNotif.smsNumberAgent = ''
  },
  [CLAIMS_CLAIMDETAIL_SAVE_FAIL](state, errMsgs) {
    state.claimDetail.saving = false
    state.claimDetail.saveError.fieldMessages = errMsgs.fieldMessages
    state.claimDetail.saveError.messages = errMsgs.messages
  },
  [CLAIMS_CLAIMDETAIL_INIT_LOADING](state) {
    state.claimDetail.init = 0
    state.claimDetail.initErr = []
    state.claimDetail.menu = {}
  },
  [CLAIMS_CLAIMDETAIL_INIT_SUCCESS](state, data) {
    state.claimDetail.init = 1
    state.claimDetail.initErr = []
    state.claimDetail.menu = data.menu
  },
  [CLAIMS_CLAIMDETAIL_INIT_FAIL](state, error) {
    state.claimDetail.init = 2
    state.claimDetail.initErr = error
    state.claimDetail.menu = {}
  },
  [CLAIMS_CLAIMDETAIL_LEAVECLAIM](state) {
    state.claimDetail.promptWhenExit = false
  },
  [CLAIMS_CLAIMDETAIL_CLAIMHANDLERS](state, hdlrData) {
    let userList = hdlrData.userList
    let handlerList = hdlrData.handlerList
    state.claimDetail.commonInfo.clmHdlrCount = handlerList ? handlerList.length : 0
    state.clmHdlr.userList = userList
    state.clmHdlr.handlerList = handlerList
    state.clmHdlr.loading = hdlrData.loading
  },
  [CLAIMS_TRANDATE_CHANGED] (state, date) {
    state.claimDetail.tranDate = date
  },
  [CLAIMS_CLAIMDETAIL_LOAD_DATA] (state, fullData) {
    const { data } = fullData
    state.claimParams.resCurrList = []
    const { remove } = fullData
    data.resCurrParam.map(currency => {
      const formatObj = {
        label: currency.label,
        value: currency.value
      }
      state.claimParams.resCurrList.push(formatObj)
    })
    state.claimDetail.remove = remove
    if (fullData.partialSave) {
      const { data } = fullData
      // For normal saving, we just want to update the revision no to prevent locking
      state.claimDetail.commonInfo.revision = data.revision
      state.claimDetail.commonInfo.claimStatuses = data.claimStatuses
      state.claimDetail.commonInfo.excess = data.excess
      state.claimDetail.commonInfo.frgnCurrRes = data.frgnCurrRes
    } else {
      const { query, menu } = fullData
      // General Data
      if (state.claimDetail.claimLifeCycle === 1 && !query) {
        state.claimDetail.claimLifeCycle = 2
      } else if (state.claimDetail.claimLifeCycle === 2 && !query) {
        state.claimDetail.claimLifeCycle = 3
      }
      // Menu (For query)
      if (menu) {
        state.claimRegister.menu = menu
      }
    }
    commitClmMaster(state, data)
    state.claimDetail.commonInfo.claimants = clone(data.claimants)
    state.claimDetail.commonInfo.createdBy = data.createdBy
    state.claimDetail.commonInfo.createdDate = data.createdDate
    state.claimDetail.commonInfo.modifiedBy = data.modifiedBy
    state.claimDetail.commonInfo.modifiedDate = data.modifiedDate
    state.claimDetail.commonInfo.clmHdlrCount = data.clmHdlrCount
    state.claimDetail.commonInfo.hasOSRes = data.hasOSRes

    state.claimDetail.commonInfo.clmPayts = data.clmPayts
    consolidateClmReses(state, data)
    state.claimDetail.commonInfo.clmRiRcvys = data.clmRiRcvys
    state.claimDetail.commonInfo.xolRcvys = data.xolRcvys
    state.claimDetail.enableResCurr = data.enableResCurr

    // update pointers
    let selectedClaimant
    if (state.claimDetail.selectedClaimant) {
      for (var claimant of data.claimants) {
        if (claimant.clmtNo === state.claimDetail.selectedClaimant.clmtNo) {
          selectedClaimant = claimant
        }
      }
    }
    state.claimDetail.selectedClaimant = selectedClaimant
    let selectedClmItem
    if (state.claimDetail.selectedClmItem && selectedClaimant) {
      for (var clmItem of selectedClaimant.clmItems) {
        if (clmItem.clmItem === state.claimDetail.selectedClmItem.clmItem) {
          selectedClmItem = clmItem
        }
      }
    }
    state.claimDetail.selectedClmItem = selectedClmItem
    state.claimDetail.commonInfo.submitReserves = []
    state.claimDetail.commonInfo.servicers = []
    state.claimDetail.commonInfo.clmAccumRes = []
    state.claimDetail.commonInfo.totAccumRes = 0
    state.claimDetail.commonInfo.totPlannedRes = 0
    state.claimDetail.commonInfo.totPaidRes = 0
    state.claimDetail.commonInfo.totAccumResLoc = 0
    state.claimDetail.commonInfo.totPlannedLoc = 0
    state.claimDetail.commonInfo.totPaidLoc = 0

    // If navFlag is 1, it is trigger from stepper
    // if (this.$route.params.navFlag === 1 || this.selectedClaimantClmtNo === 'undefined') {
    if (state.claimDetail.commonInfo.claimants) {
      for (const claimant of state.claimDetail.commonInfo.claimants) {
        if (claimant.clmItems) {
          for (const claimItem of claimant.clmItems) {
            if (claimItem.servicers) {
              for (const servicer of claimItem.servicers) {
                servicer.clmtNo = claimItem.clmtNo
                servicer.clmItem = claimItem.clmItem
                state.claimDetail.commonInfo.servicers.push(servicer)
              }
            }
            if (claimItem.clmItemReserves) {
              for (const claimItemReserve of claimItem.clmItemReserves) {
                state.claimDetail.commonInfo.submitReserves.push(claimItemReserve)
              }
            }
            if (claimItem.clmAccumRes) {
              for (const claimAccuRes of claimItem.clmAccumRes) {
                claimAccuRes.clmtNo = claimItem.clmtNo
                claimAccuRes.clmItem = claimItem.clmItem
                claimAccuRes.resCurr = claimItem.resCurr
                state.claimDetail.commonInfo.clmAccumRes.push(claimAccuRes)
              }
            }
          }
        }
      }
    } else {
      state.claimDetail.commonInfo.submitReserves = []
      state.claimDetail.commonInfo.clmAccumRes = []
      state.claimDetail.commonInfo.servicers = []
    }

    // AR: Added Number and isNaN checks
    // JJ: Multiply by 100s in calculation to avoid floating point calculation problems
    for (let res of state.claimDetail.commonInfo.clmAccumRes) {
      if (res.status !== 'P') {
        state.claimDetail.commonInfo.totAccumRes = state.claimDetail.commonInfo.totAccumRes + Number(removeFormatNumber(res.clmResOS)) * 100
        state.claimDetail.commonInfo.totAccumResLoc = state.claimDetail.commonInfo.totAccumResLoc + Number(removeFormatNumber(res.clmResOSLoc)) * 100
        state.claimDetail.commonInfo.totPlanned = state.claimDetail.commonInfo.totPlanned + Number(removeFormatNumber(res.planned)) * 100
        state.claimDetail.commonInfo.totPlannedLoc = state.claimDetail.commonInfo.totPlannedLoc + Number(removeFormatNumber(res.plannedLoc)) * 100
        state.claimDetail.commonInfo.totPlannedRes = state.claimDetail.commonInfo.totPlannedRes + Number(removeFormatNumber(res.plannedRes)) * 100
        state.claimDetail.commonInfo.totPaidLoc = state.claimDetail.commonInfo.totPaidLoc + Number(removeFormatNumber(res.paidLoc)) * 100
        state.claimDetail.commonInfo.totPaidRes = state.claimDetail.commonInfo.totPaidRes + Number(removeFormatNumber(res.paidRes)) * 100
      }
    }
    // normalize
    state.claimDetail.commonInfo.totAccumRes = isNaN(state.claimDetail.commonInfo.totAccumRes) ? 0 : state.claimDetail.commonInfo.totAccumRes / 100
    state.claimDetail.commonInfo.totPlanned = isNaN(state.claimDetail.commonInfo.totPlanned) ? 0 : state.claimDetail.commonInfo.totPlanned / 100
    state.claimDetail.commonInfo.totPlannedLoc = isNaN(state.claimDetail.commonInfo.totPlannedLoc) ? 0 : state.claimDetail.commonInfo.totPlannedLoc / 100
    state.claimDetail.commonInfo.totPlannedRes = isNaN(state.claimDetail.commonInfo.totPlannedRes) ? 0 : state.claimDetail.commonInfo.totPlannedRes / 100
    state.claimDetail.commonInfo.totAccumResLoc = isNaN(state.claimDetail.commonInfo.totAccumResLoc) ? 0 : state.claimDetail.commonInfo.totAccumResLoc / 100
    state.claimDetail.commonInfo.totPaidRes = isNaN(state.claimDetail.commonInfo.totPaidRes) ? 0 : state.claimDetail.commonInfo.totPaidRes / 100
    state.claimDetail.commonInfo.totPaidLoc = isNaN(state.claimDetail.commonInfo.totPaidLoc) ? 0 : state.claimDetail.commonInfo.totPaidLoc / 100
  },
  [CLAIMS_CLAIMDETAIL_CLAIMANT](state, data) {
    if (data) {
      state.claimDetail.selectedClaimant = data.selectedClaimant
    }
  },
  [CLAIMS_CLAIMDETAIL_CLAIMITEM](state, data) {
    if (data) {
      // Update selected Claim Item Information
      state.claimDetail.selectedClmItem = data.selectedClmItem
    }
  },
  [CLAIMS_CLAIMDETAIL_SERVICEPROVIDER](state, data) {
  },
  [CLAIMS_CLAIMDETAIL_RESERVES](state, data) {
  },
  [CLAIMS_CLAIMPAYMENT_SELECTEDRESERVES](state, data) {
    if (!data.newHeader) {
      if (data.selectedHeader) {
        state.claimPayment.selectedHeader = data.selectedHeader
      }
    } else {
      state.claimPayment.selectedHeader = {}
    }
    if (data.selectedReserves) {
      state.claimPayment.selectedReserves = data.selectedReserves
    }
    if (data.resCurr) {
      state.claimPayment.resCurr = data.resCurr
    }
    state.claimPayment.newHeader = data.newHeader
  },
  [CLAIMS_HASRIORRESADJ](state, data) {
    if (data) {
      state.clmHasRIOrResAdj.hasRIOrResAdj = data.hasRIOrResAdj
    }
  },
  [UPDATE_CLM_PEND_EXIST_LIST](state, data) {
    if (!data) return
    if (!state.clmPendExistList) {
      state.clmPendExistList = {}
    }
    const list = state.clmPendExistList
    list.paymentOverLimitList = list.paymentOverLimitList || []
    list.reverseOverLimitList = list.reverseOverLimitList || []
    if (data.promptFlagRes !== undefined) list.promptFlagRes = data.promptFlagRes
    if (data.promptFlagPay !== undefined) list.promptFlagPay = data.promptFlagPay
    if (Array.isArray(data.paymentOverLimitList)) {
      list.paymentOverLimitList = data.paymentOverLimitList
    }
    if (data.reverseOverLimitList !== undefined) {
      list.reverseOverLimitList = Array.isArray(data.reverseOverLimitList) ? data.reverseOverLimitList : []
    }
    if (data.reserveOverLimit) list.reverseOverLimitList.push(data.reserveOverLimit)
    if (data.paymentOverLimit) list.paymentOverLimitList.push(data.paymentOverLimit)
    if (data.updateById) {
      const { clmNo, docNo } = data.updateById
      const index = list.paymentOverLimitList.findIndex(item => item.clmNo === clmNo)
      if (index !== -1) {
        list.paymentOverLimitList[index] = {
          ...list.paymentOverLimitList[index],
          docNo
        }
      }
    }
  }
}

const consolidateClmReses = (state, data) => {
  const clmReses = []
  if (data && data.claimants) {
    for (const claimant of data.claimants) {
      if (claimant.clmItems) {
        for (const clmItem of claimant.clmItems) {
          if (clmItem.clmItemReserves) {
            for (const clmRes of clmItem.clmItemReserves) {
              clmReses.push(clmRes)
            }
          }
        }
      }
    }
  }
  state.claimDetail.commonInfo.clmReses = clmReses
}

const commitClmMaster = (state, data) => {
  state.claimDetail.commonInfo = {
    ...data,
    revision: data.revision,
    statusCode: data.clmStat
  }
  const { endtDate, clmClsType, cseLoss1, clmEvent, clmEventDesc, rlatClmRefNo, contrtNo, insdClmRefNo, phCltGrp, isPhGSTReg, gstRegNo, gstRegDate, prtAckLtr, cedant, liabCode, liabPct, vehRegNo, vesNo, vehVsl, resCurr, clmTxt, dept, acctNoSfx } = data
  state.claimDetail.headerForm = {
    endtDate: endtDate,
    clmClsType: clmClsType,
    cseLoss1: cseLoss1,
    clmEvent: clmEvent,
    clmEventDesc: clmEventDesc,
    rlatClmRefNo: rlatClmRefNo,
    contrtNo: contrtNo,
    insdClmRefNo: insdClmRefNo,
    phCltGrp: phCltGrp,
    isPhGSTReg: isPhGSTReg,
    gstRegNo: gstRegNo,
    gstRegDate: gstRegDate,
    prtAckLtr: prtAckLtr,
    cedant: cedant,
    liabCode: liabCode,
    liabPct: liabPct,
    vehRegNo: vehRegNo,
    vesNo: vesNo,
    vehVsl: vehVsl,
    resCurr: resCurr,
    clmTxt: clmTxt,
    dept: dept,
    acctNoSfx: acctNoSfx
  }
}
